import { sortBy, uniq } from "@/lib/array";
import Tooltip from "../Tooltip";
import PlusIcon from "../icons/PlusIcon";
import CloseIcon from "../icons/CloseIcon";

export default function ColorPicker({layers, selectedLayerIds, brandColors, onChange}) {

  brandColors = brandColors || []

  const selectedLayers = layers.filter(l => selectedLayerIds.includes(l.id))
  const value = uniq(selectedLayers.map(l => l.color))[0] || ''

  // We can remove the color from a logo layer
  const canRemoveColor = (
    selectedLayers.length === 1 &&
    selectedLayers[0].type === 'logo' &&
    selectedLayers[0].color
  )

  const defaultColors = [
    '#000000', // Black (
    '#FFFFFF', // White
  ]

  // Default brand colors if none are provided
  if (brandColors.length === 0) {
    brandColors = [
      '#0066CC', // Blue
      '#FFCC00', // Yellow
      '#CC0000', // Red
    ]
  }

  const layerColors = sortBy(layers, 'id').map(layer => layer.color).filter(color => color)

  const rows = 2
  const colorsPerRow = 7
  const maxColors = rows * colorsPerRow - 1 // -1 for the custom color
  const recommendedColors = uniq([
    ...defaultColors,
    ...brandColors,
    ...layerColors
  ].map(s => s.toUpperCase())).slice(0, maxColors)

  return (
    <div className='flex-col gap-4 full-width'>
      { recommendedColors.length > 0 &&
        <div className='flex-col gap-2'>
          <div className='grid grid-cols-7 gap-1'>
            { recommendedColors.map((color, i) => {
              return (
                <div
                  key={i}
                  className='flex-row gap-1'
                >
                  { color === '' ?
                    <div style={{width: 200}}></div>
                  :
                    <button
                      className='button border-dark-gray shadow-lg rounded-50'
                      style={{width: '2.2rem', height: '2.2rem', backgroundColor: color}}
                      onClick={e => onChange(color)}
                    >
                    </button>
                  }
                </div>
              )
            })}

            <div className="relative">
              <input
                className='button border border-gray shadow rounded-50'
                style={{width: '2.2rem', height: '2.2rem', opacity: 0.01}}
                type="color"
                value={value || '#ffffff'}
                onChange={e => onChange(e.target.value)}
              />
              <div
                className='absolute-full flex flex-justify-center flex-align-center button border border-gray shadow rounded-50 z-1 pointer-events-none'
                style={{
                  width: '2.2rem',
                  height: '2.2rem',
                  background: 'white',
                  border: '1px dashed #3499CC',
                }}
              >
                <div className='absolute-full flex flex-justify-center flex-align-center blue'>
                  <PlusIcon/>
                </div>
              </div>
              <Tooltip>
                Pick a Color
              </Tooltip>
            </div>

            {/* This maintains the tight packing of the grid when there are too few colors */}
            { recommendedColors.length < 6 &&
              <div style={{width: 400}}/>
            }

            { canRemoveColor &&
              <>
                <button
                  onClick={e => onChange('')}
                  className='button flex flex-justify-center flex-align-center button border border-gray shadow rounded-50 z-1'
                  style={{
                    width: '2.2rem',
                    height: '2.2rem',
                    background: 'white',
                    border: '1px dashed red',
                  }}
                >
                  <div className='red absolute-full flex flex-justify-center flex-align-center'>
                    <CloseIcon/>
                  </div>
                  <Tooltip>
                    Remove Color
                  </Tooltip>
                </button>
              </>
            }
          </div>
        </div>
      }

    </div>
  );
}